import ViewBtn from "@/components/Buttons/ViewBtn";
import CommonDelete from "@/components/CommonUi/CommonDelete";
import CreateDrawer from "@/components/CommonUi/CreateDrawer";
import TableComponent from "@/components/CommonUi/TableComponent";
import {
  deleteTask,
  loadAllTaskPaginated,
  updateTask,
} from "@/redux/rtk/features/CRM/task/taskSlice";
import { EditOutlined } from "@ant-design/icons";
import { Select, Tag } from "antd";
import moment from "moment/moment";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import AddTask from "../../CRM/Task/AddTask";

export default function LeadTasks({ leadId }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { list, loading, total } = useSelector((state) => state.task);

  const [pageConfig, setPageConfig] = useState({
    status: true,
    page: 1,
    count: 10,
    leadId: leadId,
  });

  useEffect(() => {
    setPageConfig((prev) => ({ ...prev, leadId: leadId }));
  }, [leadId]);

  const statusOptions = [
    { label: t("task.pending"), value: "معلق", color: "orange" },
    { label: t("task.completed"), value: "مكتمل", color: "green" },
  ];

  const handleStatusChange = async (taskId, statusValue) => {
    const resp = await dispatch(updateTask({ id: taskId, values: { taskStatus: statusValue } }));
    if (resp.payload.message === "success") {
      dispatch(loadAllTaskPaginated(pageConfig));
    }
  };

  const columns = [
    {
      title: t("common.id"),
      key: "id",
      dataIndex: "id",
    },
    {
      title: t("common.name"),
      key: "Name",
      render: ({ name, id }) => <Link to={`/admin/task/${id}`}>{name}</Link>,
      renderCsv: ({ name }) => name,
    },
    {
      title: t("common.status"),
      dataIndex: "taskStatus",
      render: (taskStatus, record) => (
        <Select
          defaultValue={taskStatus || "معلق"}
          style={{ width: 120 }}
          bordered={false}
          onClick={(e) => e.stopPropagation()}
          onChange={(value) => handleStatusChange(record.id, value)}
        >
          {statusOptions.map((opt) => (
            <Select.Option key={opt.value} value={opt.value}>
              <Tag color={opt.color}>{opt.label}</Tag>
            </Select.Option>
          ))}
        </Select>
      ),
    },
    {
      title: t("task.dueDate") || "Due Date",
      dataIndex: "dueDate",
      render: (date) => (date ? moment(date).format("MMMM Do YYYY") : "-"),
      renderCsv: (date) => (date ? moment(date).format("MMMM Do YYYY") : "-"),
    },
    {
      title: t("task.assignee") || "Assignee",
      dataIndex: "assignee",
      render: (assignee, item) => (
        <Link to={`/admin/setup/staffs/${item?.assigneeId}`}>
          {assignee?.firstName} {assignee?.lastName}
        </Link>
      ),
      renderCsv: (assignee) => `${assignee?.firstName} ${assignee?.lastName}`,
    },
    {
      title: t("common.createDate"),
      dataIndex: "createdAt",
      render: (date) => (date ? moment(date).format("MMMM Do YYYY") : "-"),
      renderCsv: (date) => (date ? moment(date).format("MMMM Do YYYY") : "-"),
    },
    {
      id: 4,
      title: "",
      key: "action",
      render: (item) => [
        {
          label: <ViewBtn title={t("common.view")} path={`/admin/task/${item?.id}`} />,
          key: "view",
        },
        {
          label: (
            <Link
              to={`/admin/task/${item?.id}`}
              className="flex items-center gap-2 cursor-pointer">
              <EditOutlined className=" rounded-md" />
              {t("common.edit")}
            </Link>
          ),
          key: "edit",
        },
        {
          label: (
            <CommonDelete
              id={item.id}
              title={t("common.delete")}
              permission={"delete-tasks"}
              deleteThunk={deleteTask}
              loadThunk={loadAllTaskPaginated}
              query={pageConfig}
              className="bg-white text-black"
            />
          ),
          key: "delete",
        },
      ],
      csvOff: true,
    },
  ];

  useEffect(() => {
    dispatch(loadAllTaskPaginated(pageConfig));
  }, [dispatch, pageConfig]);

  return (
    <div className="pt-4">
        <TableComponent
          list={list}
          columns={columns}
          loading={loading}
          total={total}
          setPageConfig={setPageConfig}
          onRow={(item) => ({
            onClick: () => navigate(`/admin/task/${item?.id}`),
            className: "cursor-pointer",
          })}
          title={t("task.title") + " " + (t("common.list") || "List")}
          isSearch
          columnKey="lead_tasks_table"
          componentTitle={t("task.title")}
          extra={
            <CreateDrawer
              permission={"create-tasks"}
              title={t("task.addTask") || "Create Task"}
              width={60}>
              <AddTask createAs={{ name: "leadId", value: leadId }} />
            </CreateDrawer>
          }
        />
    </div>
  );
}
